import React, { useEffect } from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
//
import logo1 from "images/logos/nomal/1.png";
import logo1Dark from "images/logos/dark/1.png";
//
import logo2 from "images/logos/nomal/2.png";
import logo2Dark from "images/logos/dark/2.png";
//
import logo3 from "images/logos/nomal/3.png";
import logo3Dark from "images/logos/dark/3.png";
//
import logo4 from "images/logos/nomal/4.png";
import logo4Dark from "images/logos/dark/4.png";
//
import logo5 from "images/logos/nomal/5.png";
import logo5Dark from "images/logos/dark/5.png";
//
import { useGetStoriesQuery } from "store/api/storiesApi";
import SectionSliderStories from "components/SectionSliderStories/SectionSliderStories";
import SectionSliderBanner from "components/SectionSliderBanner/SectionSliderBanner";
import { useGetBannersQuery } from "store/api/bannersApi";
import SectionFilter from "components/SectionFilter/SectionFilter";
import SectionEventsShop from './SectionEventsShop';
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";

function PageHome2() {
  // CUSTOM THEME STYLE
  const {data:storiesData,isLoading:isStoriesLoading} = useGetStoriesQuery({});
  const {data:bannersData,isLoading:isBannersLoading} = useGetBannersQuery({});
  let stories = storiesData?.list;
  let banners = bannersData?.list;
  useEffect(() => {
    const $body = document.querySelector("body");
    if (!$body) return;
    $body.classList.add("theme-cyan-blueGrey");
    return () => {
      $body.classList.remove("theme-cyan-blueGrey");
    };
  }, []);

  return (
    <div className="nc-PageHome2 relative overflow-hidden">
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative space-y-24 mb-24 lg:space-y-28 lg:mb-28">
        { !isStoriesLoading && <SectionSliderStories itemPerRow={5} uniqueClassName="StoriesSlider" stories={stories} />}
        { !isBannersLoading && <SectionSliderBanner banners={banners} uniqueClassName="BannersSlider"/> }
        {/* SECTION 1 */}
        <div className="ncSectionLogos grid grid-cols-3 lg:grid-cols-5 gap-5 sm:gap-16">
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo1} alt="logo1" />
            <img className="hidden dark:block" src={logo1Dark} alt="logo1" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo4} alt="logo4" />
            <img className="hidden dark:block" src={logo4Dark} alt="logo4" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo2} alt="logo2" />
            <img className="hidden dark:block" src={logo2Dark} alt="logo2" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo3} alt="logo3" />
            <img className="hidden dark:block" src={logo3Dark} alt="logo3" />
          </div>

          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo5} alt="logo5" />
            <img className="hidden dark:block" src={logo5Dark} alt="logo5" />
          </div>
        </div>
        <div className="relative py-8 space-y-8 mb-8 lg:space-y-8 lg:mb-8">
          <BackgroundSection />
          <SectionFilter />
          <SectionEventsShop />
        </div>

        {/* SECTION2 */}
        {/* <SectionOurFeatures type="type2" rightImg={rightImgPng} /> */}

        {/* SECTION */}
        {/* <SectionDowloadApp /> */}

        {/* SECTION */}
        <div className="relative py-16">
          <BackgroundSection className="bg-neutral-100 dark:bg-black dark:bg-opacity-20 " />
          <SectionGridAuthorBox boxCard="box2" />
        </div>
      </div>
    </div>
  );
}

export default PageHome2;
